<template>
  <div class="intro" id="top">
    <section class="">
      <div class="hero-body">
        <div class="container media is-align-center">
          <figure class="media-left">
            <a class="link is-info" href="/batch/view">
              <img
                alt="InteGreat logo"
                class="is-hidden-mobile"
                src="../assets/logo.png"
              />
              <img
                alt="InteGreat logo"
                class="is-hidden-desktop"
                src="../assets/logo-mobile1.png"
              />
            </a>
          </figure>
          <div class="media-content has-text-centered">
            <div class="content">
              <h2 class="title is-2">{{ title }}</h2>
              <h5 class="subtitle is-5">{{ subtitle }}</h5>
            </div>
          </div>
          <div class="media-right">
            <b-dropdown
              aria-role="list"
              position="is-bottom-left"
              class="language-dropdown"
            >
              <template #trigger>
                <b-button icon-right="chevron-down">{{
                  $i18n.locale === "en" ? "EN" : "TH"
                }}</b-button>
              </template>

              <b-dropdown-item
                @click="setLanguage('en')"
                aria-role="listitem "
                :class="{ active: $i18n.locale === 'en' }"
              >
                <b-button icon-right="check">EN</b-button></b-dropdown-item
              >
              <b-dropdown-item
                @click="setLanguage('th')"
                aria-role="listitem"
                :class="{ active: $i18n.locale === 'th' }"
              >
                <b-button icon-right="check">TH</b-button></b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="box">
        <step
          :id="stepId"
          v-if="steps && rule === 'admin'"
          :stepIndex="stepIndex"
        ></step>

        <stepStartup
          :id="stepId"
          v-if="steps && rule === 'startup'"
          :stepIndex="stepIndex"
        ></stepStartup>

        <stepStaff
          :id="stepId"
          v-if="steps && rule === 'staff'"
          :stepIndex="stepIndex"
        ></stepStaff>

        <stepBoard
          :id="stepId"
          v-if="steps && rule === 'board'"
          :stepIndex="stepIndex"
        ></stepBoard>

        <stepExclusiveBoard
          :id="stepId"
          v-if="steps && rule === 'exclusiveboard'"
          :stepIndex="stepIndex"
        ></stepExclusiveBoard>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import StepsWizard from "bulma-extensions/bulma-steps/dist/js/bulma-steps.min";
import "bulma-extensions/bulma-steps/dist/js/bulma-steps.min";
import Step from "@/components/Step.vue";
import stepStartup from "@/components/StepStartup.vue";
import stepStaff from "@/components/StepStaff.vue";
import stepBoard from "@/components/StepBoard.vue";
import stepExclusiveBoard from "@/components/StepExclusiveBoard.vue";
import { mapGetters } from "vuex";

export default {
  name: "DefaultTemplate",
  components: {
    Step,
    stepStartup,
    stepStaff,
    stepExclusiveBoard,
    stepBoard,
  },
  props: {
    title: String,
    subtitle: String,
    stepId: String,
    steps: Boolean,
  },
  data() {
    return {
      currentStep: "User information",
      rule: this.$route.params.rule,
      widthMax: window.innerWidth,
      stepIndex: null,
    };
  },
  computed: {
    getRule() {
      return this.$store.getters.getRule;
    },
    token() {
      return this.$store.state.token;
    },
  },
  methods: {
    fetchInitData() {
      if (this.stepId) {
        this.stepIndex = new StepsWizard(document.getElementById(this.stepId));
      }
      // this.stepIndex.activate_step(1);
    },
    setLanguage(data) {
      this.$i18n.locale = data;
      this.$store.commit("setLanguage", data);
    },
  },
  mounted() {
    this.fetchInitData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "/node_modules/bulma-extensions/bulma-steps/dist/css/bulma-steps.min.css";

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.logoBox {
  width: 2rem;
}
.hero {
}
.hero-body {
  padding: 30px 1.5rem !important;
}

.hero-body .media-left {
  width: 200px;
}

.hero-body .media-right {
  width: 200px;
  text-align: right;
}
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .box {
    padding-bottom: calc(100% - 1 * 20px - 650px) !important;
    border-radius: 0;
    -webkit-box-shadow: 0 0px 0px rgba(10, 10, 10, 0.1),
      0 0 0 0px rgba(10, 10, 10, 0.1);
    box-shadow: 0 0px 0px rgba(10, 10, 10, 0.1), 0 0 0 0px rgba(10, 10, 10, 0.1);
  }
}
@media screen and (min-width: 100px) and (max-width: 767px) {
  .title.is-2 {
    font-size: 26px;
  }
  .subtitle.is-5 {
    font-size: 12px;
  }
  .box {
    border-radius: 0;
    border-radius: 0;
    -webkit-box-shadow: 0 0px 0px rgba(10, 10, 10, 0.1),
      0 0 0 0px rgba(10, 10, 10, 0.1);
    box-shadow: 0 0px 0px rgba(10, 10, 10, 0.1), 0 0 0 0px rgba(10, 10, 10, 0.1);
  }
  .logoBox {
    width: 5rem;
  }
  .hero-body {
    padding: 30px 0.5rem !important;
  }
}
</style>
